import type { GetResourcesInput, ResourceCreateDto, ResourceDto, ResourceUpdateDto, ResourceWithNavigationPropertiesDto } from './models';
import { RestService } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { LookupDto, LookupRequestDto } from '../shared/models';

@Injectable({
  providedIn: 'root',
})
export class ResourceService {
  apiName = 'Analysis';

  create = (input: ResourceCreateDto) =>
    this.restService.request<any, ResourceDto>({
      method: 'POST',
      url: `/api/analysis/resources`,
      body: input,
    },
    { apiName: this.apiName });

  delete = (id: string) =>
    this.restService.request<any, void>({
      method: 'DELETE',
      url: `/api/analysis/resources/${id}`,
    },
    { apiName: this.apiName });

  get = (id: string) =>
    this.restService.request<any, ResourceDto>({
      method: 'GET',
      url: `/api/analysis/resources/${id}`,
    },
    { apiName: this.apiName });

  getList = (input: GetResourcesInput) =>
    this.restService.request<any, PagedResultDto<ResourceWithNavigationPropertiesDto>>({
      method: 'GET',
      url: `/api/analysis/resources`,
      params: { filterText: input.filterText, name: input.name, description: input.description, uri: input.uri, resourceTypeId: input.resourceTypeId, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getResourceTypeLookup = (input: LookupRequestDto) =>
    this.restService.request<any, PagedResultDto<LookupDto<string>>>({
      method: 'GET',
      url: `/api/analysis/resources/resource-type-lookup`,
      params: { filter: input.filter, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName });

  getWithNavigationProperties = (id: string) =>
    this.restService.request<any, ResourceWithNavigationPropertiesDto>({
      method: 'GET',
      url: `/api/analysis/resources/with-navigation-properties/${id}`,
    },
    { apiName: this.apiName });

  update = (id: string, input: ResourceUpdateDto) =>
    this.restService.request<any, ResourceDto>({
      method: 'PUT',
      url: `/api/analysis/resources/${id}`,
      body: input,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
